import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { PriceTypeCode } from '../models/PriceTypeCode';
import { SelectItem } from '../models/SelectItem';

const CACHE_SIZE = 1;

@Injectable({
  providedIn: 'root',
})
export class PriceTypeCodeService {
  apiRoot: string;
  types: SelectItem[] = [];

  constructor(private http: HttpClient) {
    this.apiRoot = environment.cmApiRoot.url;
  }


  public getPriceTypeCodeList(): Observable<PriceTypeCode[]> {

    return this.http.get<PriceTypeCode[]>(`${this.apiRoot}/api/ContractPriceTypeCodes`);
  }


}
